import { IBusinessType } from "modules/Utilities/ConfigureAgreement/BusinessType/type/BusinessTypeInterface";
import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/BusinessType";

//Add BusinessType
export const addBusinessType = async (newData: IBusinessType) => {
  const { data } = await axios.post(`${api_base_url}`, newData);
  return data;
};

//Delete BusinessType
export const deleteBusinessType = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/BusinessType`, {
    data: ids,
  });
  return data;
};

//Update BusinessType
export const updateBusinessType = async (updatedBusinessType) => {
  const { data } = await axios.put(`${api_base_url}`, updatedBusinessType);
  return data;
};

export const getBusinessTypes = () => {
  return axios.get(`${api_base_url}/GetBusinessTypes`).then((res) => {
    return res;
  });
};
